/**
 * Lazy-loaded route components configuration
 * Grouped by feature for better code splitting
 * Uses lazyWithRetry to handle chunk load failures gracefully
 */

import { lazyWithRetry } from '@/lib/utils/lazyWithRetry';

// Auth-related (non-critical)
export const authRoutes = {
  ForgotPassword: lazyWithRetry(() => import('@/pages/auth/ForgotPassword')),
  ResetPassword: lazyWithRetry(() => import('@/pages/auth/ResetPassword')),
  EmailSent: lazyWithRetry(() => import('@/pages/auth/EmailSent')),
  EmailConfirmation: lazyWithRetry(() => import('@/pages/auth/EmailConfirmation')),
  PasswordResetConfirmation: lazyWithRetry(() => import('@/pages/auth/PasswordResetConfirmation')),
  AuthCallback: lazyWithRetry(() => import('@/pages/auth/AuthCallback')),
};

// Onboarding
export const onboardingRoutes = {
  OnboardingCarousel: lazyWithRetry(() => import('@/pages/OnboardingCarousel')),
  Onboarding110: lazyWithRetry(() => import('@/pages/Onboarding110')),
};

// Catalog & Pet details
export const catalogRoutes = {
  AnimalDetail: lazyWithRetry(() => import('@/pages/AnimalDetail')),
  PetDetail: lazyWithRetry(() => import('@/pages/PetDetail')),
};

// User profile & settings
export const profileRoutes = {
  Profile: lazyWithRetry(() => import('@/pages/Profile')),
  Profile101: lazyWithRetry(() => import('@/pages/Profile101')),
  Profile102: lazyWithRetry(() => import('@/pages/Profile102')),
  CuratorProfile: lazyWithRetry(() => import('@/pages/CuratorProfile')),
  SettingsScreen: lazyWithRetry(() => import('@/pages/SettingsScreen')),
  AboutScreen: lazyWithRetry(() => import('@/pages/AboutScreen')),
};

// Ads management
export const adsRoutes = {
  MyAdsScreen: lazyWithRetry(() => import('@/pages/MyAdsScreen')),
  ADS002CreateAd: lazyWithRetry(() => import('@/pages/ADS002CreateAd')),
  ADS002AICreate: lazyWithRetry(() => import('@/pages/ADS002AICreate')),
  ADS003EditAd: lazyWithRetry(() => import('@/pages/ADS003EditAd')),
  FavoritesScreen: lazyWithRetry(() => import('@/pages/FavoritesScreen')),
};

// Chat
export const chatRoutes = {
  ChatListScreen: lazyWithRetry(() => import('@/pages/ChatListScreen')),
  ChatRoomScreen: lazyWithRetry(() => import('@/pages/ChatRoomScreen')),
};

// Quiz - all steps lazy loaded
export const quizRoutes = {
  Quiz001Intro: lazyWithRetry(() => import('@/pages/Quiz001Intro')),
  Quiz002Intro: lazyWithRetry(() => import('@/pages/Quiz002Intro')),
  Quiz002Step2: lazyWithRetry(() => import('@/pages/Quiz002Step2')),
  Quiz002Step3: lazyWithRetry(() => import('@/pages/Quiz002Step3')),
  Quiz002Step4: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step4')),
  Quiz002Step5: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step5')),
  Quiz002Step6: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step6')),
  Quiz002Step7: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step7')),
  Quiz002Step8: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step8')),
  Quiz002Step9: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step9')),
  Quiz002Step10: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step10')),
  Quiz002Step11: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step11')),
  Quiz002Step12: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step12')),
  Quiz002Step13: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step13')),
  Quiz002Step14: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step14')),
  Quiz002Step15: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step15')),
  Quiz002Step16: lazyWithRetry(() => import('@/pages/quiz/Quiz002Step16')),
  Quiz003Processing: lazyWithRetry(() => import('@/pages/quiz/Quiz003Processing')),
  Quiz004Results: lazyWithRetry(() => import('@/pages/quiz/Quiz004Results')),
  QuizExitDialog: lazyWithRetry(() => import('@/pages/QuizExitDialog')),
  UserQuizProfilePage: lazyWithRetry(() => import('@/pages/UserQuizProfilePage')),
};

// Admin & Moderation
export const adminRoutes = {
  AdminScreen: lazyWithRetry(() => import('@/pages/AdminScreen')),
  ModerationScreen: lazyWithRetry(() => import('@/pages/ModerationScreen')),
};

// Misc
export const miscRoutes = {
  Form: lazyWithRetry(() => import('@/pages/Form')),
  Done: lazyWithRetry(() => import('@/pages/Done')),
  MaintenancePage: lazyWithRetry(() => import('@/pages/MaintenancePage')),
};
